import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { FundTypeEnum, InventoryActionEnum } from '~utils/enums';

export default function* watchExportInventoryDeliveredListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldExportInventoryDeliveredListingAttempt', handleExportInventoryDeliveredListing, api);
}

function* handleExportInventoryDeliveredListing(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { filters: { branchCode, productId, serialNo, fundType } } = reduxState.gold.goldInventoryReport.inventoryDelivered;

    const response = yield* call([api, api.getInventoryTransfers], {
        authToken,
        index: 0,
        action: InventoryActionEnum.TransferFrom,
        branchCode: branchCode || undefined,
        productId: productId || undefined,
        serialNo: serialNo || undefined,
        fundType: FundTypeEnum[fundType as keyof typeof FundTypeEnum] || undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldExportInventoryDeliveredListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldExportInventoryDeliveredListingSuccess(response.data.data));
    }
}
